










import Vue from 'vue'

export default Vue.extend({
  props: {
    borderColor: {
      type: String,
      default: '',
    },
    loading: {
      type: [Boolean, String],
      default: false,
    },
    innerClass: {
      type: String,
      default: 'event-card-container-inner',
    },
    to: {
      type: Object,
      default: null,
    },
  },
})
